export function Or(guards) {
    return (arg) => guards.some(predicate => predicate(arg));
}
export function And(guards) {
    return (arg) => guards.every(predicate => predicate(arg));
}
